import { FiExternalLink } from 'react-icons/fi'

import i from 'i18next'
type HeaderAdProps = {
  campaignURL: string
  campaignName: string
}

const HeaderAd = ({ campaignURL, campaignName }: HeaderAdProps) => (
  <header>
    <strong className="fs-6">
      {i.t('rm:Campaign')}:{' '}
      <a
        target="_blank"
        href={campaignURL}
        rel="noreferrer"
        className="d-inline-flex align-items-center gap-1"
      >
        {campaignName} <FiExternalLink />
      </a>
    </strong>
  </header>
)

export default HeaderAd
